<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-if="isDetail" class="page-number">
    <span class="number">01</span>
  </div>
  <div v-else class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1023 45">
    <g id="yema5" transform="translate(-1 -12)">
      <g id="组_4655" data-name="组 4655" transform="translate(-83 -1223)">
        <text id="_01" data-name="01" transform="translate(574.55 1269)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
        <rect id="矩形_2885" data-name="矩形 2885" width="462" height="1" transform="translate(645 1257)" fill="var(--theme-color-1)"/>
        <rect id="矩形_2889" data-name="矩形 2889" width="462" height="1" transform="translate(84 1257)" fill="var(--theme-color-1)"/>
      </g>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.svg-block {
  width: 420px !important;
  position: absolute;
  bottom: 10px;
  left: 0;
  padding: 0 20px;
}

.page-number {
  display: flex;
  align-items: center;
  justify-content: center;
  &::after,
  &::before {
    content: '';
    flex-grow: 1;
    height: 1px;
    background-color: var(--theme-color-1);
    display: block;
  }
}
.number {
  padding: 0 5px;
  font-size: 20px;
  font-weight: 600;
  color: var(--theme-color-1);
}
</style>
